import { Params } from '../data';
import { SettingsProvider } from './common.types';
import { PageContext } from './page.types';
import { Section } from './section.types';

export type ModalContext = PageContext & {
  modalParams: Params;
};

export type ModalSize = 'sm' | 'md' | 'lg' | 'xl';

export type ModalDsl = {
  title: string;
  size: ModalSize;
  sections: Section[];
  settings?: SettingsProvider;
  name: ModalName;
};
export enum ModalName {
  KeyIndicators = 'key indicators',
  Heatmap = 'heatmap',
  Trends = 'trends',
}
